import styled from 'styled-components'

export default styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.justifyContent ? props.justifyContent : 'center'};
  align-content: center;
  align-items: center;
  width: 570px;
  height: ${props => props.height ? props.height : '100%'};
  min-height: 100vh;
  padding-bottom: 20px;
  background: ${props => props.background ? props.background : 'white'};
  box-sizing: border-box;
  
  @media (max-width: 570px) {
    min-height: 500px;
    justify-content: ${props => props.justifyContent ? props.justifyContent : 'start'};
    height: 100%;
    width: 100%;
  }
`